module.exports = __webpack_public_path__ + "img/cameramanager-logo.27a1e969.png";